import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d185b43a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d185b43a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d185b43a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d185b43a')) {
      api.createRecord('d185b43a', component.options)
    } else {
      api.reload('d185b43a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d185b43a&scoped=true", function () {
      api.rerender('d185b43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/UserDialog/index.vue"
export default component.exports